export default "__VITE_ASSET__604bcb5f__"